export default __webpack_public_path__ + "static/media/mn_tea_sub_1.8028d107.png";